import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@shared/ui/accordion";
import { ChevronDown } from "lucide-react";
import { cn } from "@shared/lib/utils";

type ConsumptionEntry = {
  month: string;
  value: number;
  color?: string;
};

type Props = {
  title?: string;
  data: ConsumptionEntry[];
};

export const ConsumptionHistory: React.FC<Props> = ({
  title = "Consumption History",
  data,
}) => {
  const max = Math.max(...data.map((d) => d.value), 1); // fallback to 1 if all zero

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="item-1"
      className="bg-white w-full"
    >
      <AccordionItem value="item-1">
        <AccordionTrigger className="px-4 py-2 flex justify-between items-center w-full text-left text-sm font-semibold text-gray-700 bg-muted border rounded-md">
          {title}
        </AccordionTrigger>
        <AccordionContent className="px-4 pb-4 pt-2 space-y-3 border rounded-md rounded-t-none">
          {data.map(({ month, value, color = "bg-blue-500" }, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <div className="w-10 text-xs text-gray-500">{month}</div>
              <div className="flex-1 bg-gray-100 h-4 rounded">
                <div
                  className={cn("h-4 rounded", color)}
                  style={{
                    width: `${Math.max(
                      0,
                      Math.min(100, (value / max) * 100)
                    )}%`,
                  }}
                />
              </div>
              <div className="w-10 text-xs text-right text-gray-700 font-medium">
                {value}
              </div>
            </div>
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
